var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page white_bg"},[_c('div',{staticClass:"paddingV12 paddingH16"},[_c('button',{staticClass:"button button_primary white",on:{"click":function($event){return _vm.getLocation()}}},[_vm._v("获取定位")])])])}
var staticRenderFns = []

export { render, staticRenderFns }